import React, {useRef} from "react";

function SolrSearchInput({ hideLabel, onSearchQuery, label, value }) {
  const inputRef = useRef(null);
  function handleSubmit(event) {
    event.preventDefault();
    const formData = new FormData(event.target);
    const query = formData.get('solr-search-textfield');
    onSearchQuery({ query });
  }

  if (inputRef.current) {
    inputRef.current.value = value;
  }

  return (
    <form className="solr-search-input" onSubmit={handleSubmit}>
      <label className={hideLabel ? 'visually-hidden' : 'h4 filter-label'} htmlFor="solr-search-input"> { label } </label>
      <div className="form-element">
        <input ref={inputRef} defaultValue={value} onBlur={(e) => onSearchQuery({query: e.target.value})} name='solr-search-textfield' id="solr-search-input" type="text" placeholder="Enter Search Term" />
        <button type="submit">
          <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="21" cy="21" r="21" fill="#F7EDE4"/>
            <path d="M27.5001 24.5003C29.9851 22.0152 29.9851 17.9851 27.5001 15.5001C25.0151 13.0151 20.9849 13.0151 18.4999 15.5001C16.2985 17.7015 16.05 21.1158 17.749 23.5927L14.2834 26.6909C13.6919 27.2176 13.6676 28.1333 14.2267 28.6925L14.3077 28.7735C14.8669 29.3326 15.7826 29.3083 16.3093 28.7168L19.4075 25.2512C21.8871 26.9529 25.2987 26.7017 27.5001 24.5003ZM20.045 22.9552C18.4135 21.3238 18.4135 18.6766 20.045 17.0452C21.6764 15.4137 24.3236 15.4137 25.955 17.0452C27.5865 18.6766 27.5865 21.3238 25.955 22.9552C24.3209 24.5894 21.6764 24.5867 20.045 22.9552Z" fill="#342649"/>
          </svg>
        </button>
      </div>
    </form>
  );
}

export default SolrSearchInput;
